import { SuperuserModelsPage } from "@/features/superuser/models/superuser-models.page";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/superuser/models")({
  component: SuperuserModelsPage,
});
